import * as React from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/cn';

export interface LinkEditorProps extends React.ComponentProps<'div'> {
  defaultUrl?: string;
  defaultText?: string;
  defaultIsNewTab?: boolean;
  onSave: (url: string, text?: string, isNewTab?: boolean) => void;
  onCancel: () => void;
}

export const LinkEditBlock = ({
  onSave,
  defaultIsNewTab,
  defaultUrl,
  defaultText,
  className,
  onCancel,
}: LinkEditorProps) => {
  const formRef = React.useRef<HTMLDivElement>(null);
  const [url, setUrl] = React.useState(defaultUrl || '');
  const [text, setText] = React.useState(defaultText || '');
  const [isNewTab, setIsNewTab] = React.useState(defaultIsNewTab || false);

  const handleSave = React.useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      if (formRef.current) {
        const isValid = Array.from(
          formRef.current.querySelectorAll('input')
        ).every((input) => input.checkValidity());

        if (isValid) {
          onSave(url, text, isNewTab);
        } else {
          formRef.current.querySelectorAll('input').forEach((input) => {
            if (!input.checkValidity()) {
              input.reportValidity();
            }
          });
        }
      }
    },
    [onSave, url, text, isNewTab]
  );

  return (
    <div ref={formRef}>
      <div className={cn('space-y-4', className)}>
        <div className='space-y-1'>
          <Label>URL</Label>
          <Input
            type='url'
            required
            placeholder='Infoga URL'
            value={url}
            onChange={(e) => setUrl(e.target.value)}
          />
        </div>

        <div className='space-y-1'>
          <Label>Text (valfri)</Label>
          <Input
            type='text'
            placeholder='Enter display text'
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
        </div>

        <div className='flex items-center space-x-2'>
          <Label>Öppna i ny flik</Label>
          <Switch checked={isNewTab} onCheckedChange={setIsNewTab} />
        </div>

        <div className='flex justify-end space-x-2'>
          <Button type='button' variant='outline' onClick={onCancel}>
            Avbryt
          </Button>
          <Button type='button' onClick={handleSave} disabled={!url}>
            Spara
          </Button>
        </div>
      </div>
    </div>
  );
};
